/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Grid_Not_Initialized_ToastInputs */

const en_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid not initialized`)
};

const fr_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grille non initialisee`)
};

const de_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid nicht initialisiert`)
};

const it_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griglia non inizializzata`)
};

const ru_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сетка не инициализирована`)
};

const es_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadrícula no inicializada`)
};

const zh_cn2_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网格未初始化`)
};

const ja_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリッドが初期化されていません`)
};

const hi_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रिड आरंभ नहीं हुआ`)
};

const pt_pt2_knp_lookup_grid_not_initialized_toast = /** @type {(inputs: Knp_Lookup_Grid_Not_Initialized_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade não inicializada`)
};

/**
* | output |
* | --- |
* | "Grid not initialized" |
*
* @param {Knp_Lookup_Grid_Not_Initialized_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_grid_not_initialized_toast = /** @type {((inputs?: Knp_Lookup_Grid_Not_Initialized_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Grid_Not_Initialized_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "de") return de_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "it") return it_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "es") return es_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_grid_not_initialized_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_grid_not_initialized_toast(inputs)
	return en_knp_lookup_grid_not_initialized_toast(inputs)
});